import React from 'react';
import { View, Modal } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { useTheme } from '../Themes';
import VFLottieView from '../VFLottieView';
import VFText from '../VFText';

import Styles from './VFLottieLoadingScreen.Styles';

const VFLottieLoadingScreen = ({
  isVisible,
  title,
  titlePlaceHolders,
  subTitle,
  subTitlePlaceHolders,
  containerStyle,
  lottieViewStyle,
  titleStyle,
  subTitleStyle,
  ...props
}) => {
  const theme = useTheme();

  return (
    <Modal
      presentationStyle="fullScreen"
      statusBarTranslucent
      {...props}
      visible={isVisible}
      onRequestClose={() => {}}
    >
      <View style={[Styles.containerStyle(theme), containerStyle]}>
        <VFLottieView
          type="spinner"
          autoPlay
          loop
          style={[Styles.lottieViewStyle, lottieViewStyle]}
        />
        {title ? (
          <VFText
            i18nKey={title}
            style={[Styles.titleStyle(theme), titleStyle]}
            placeHolders={titlePlaceHolders}
          />
        ) : null}
        {subTitle ? (
          <VFText
            i18nKey={subTitle}
            style={[Styles.subTitleStyle(theme), subTitleStyle]}
            placeHolders={subTitlePlaceHolders}
          />
        ) : null}
      </View>
    </Modal>
  );
};

VFLottieLoadingScreen.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  title: PropTypes.string,
  titlePlaceHolders: PropTypes.arrayOf(PropTypes.string),
  subTitle: PropTypes.string,
  subTitlePlaceHolders: PropTypes.arrayOf(PropTypes.string),
  containerStyle: ViewPropTypes.style,
  lottieViewStyle: ViewPropTypes.style,
  titleStyle: TextPropTypes.style,
  subTitleStyle: TextPropTypes.style,
};
export default VFLottieLoadingScreen;
